var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('img',{staticClass:"ui-spinner",class:{ 'absolute': _vm.absolute },attrs:{"src":require("images/icons/spinner.svg")}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }